import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS, SIZE_MAX, DIST_MAX } from '@framework/workbench/drawer/ui/chart/global-settings/chart-effect/chart-shadow/config';
import { Form, NumberInputFrom, AngleFrom, DragAngleCircleType } from '@tencent/wb-ext-form';
import { IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { IChartShadowFeature } from './chart-shadow-interface';
import { ANGLE_MAX } from '@framework/workbench/drawer/common/config';

@Controller({ formItems: FORM_CONFIGS })
export class ChartGlobalShadowController {
    constructor(@Loader(IChartShadowFeature) private loader: IDynamicLoader<IChartShadowFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW, 'content')
    public renderPreset() {
        return this.feature.renderPreset();
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE, 'value')
    public getSize(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW, { size: this.feature.size });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE, 'onChange')
    public changeSize(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const sizeObj = this.feature.getValidValue({ size: value }, from, SIZE_MAX);
        sizeObj.sizeX = sizeObj.value;
        sizeObj.sizeY = sizeObj.value;
        this.feature.handleShadowChange(sizeObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE, 'shouldDisabled')
    public shouldSizeDisabled(): boolean {
        return !this.feature.shadowInfo.isOuter;
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_BLUR, 'value')
    public getBlur(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW, { blurRad: this.feature.blur });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_BLUR, 'onChange')
    public changeBlur(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const blurRadObj = this.feature.getValidValue({ blurRad: value }, from);
        this.feature.handleShadowChange(blurRadObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_DISTANCE, 'value')
    public getDist(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW, { dist: this.feature.dist });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_DISTANCE, 'onChange')
    public changeDist(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const distObj = this.feature.getValidValue({ dist: value }, from, DIST_MAX);
        this.feature.handleShadowChange(distObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_OPICITY, 'value')
    public getOpacity(): number | IMultiDiffValue {
        return this.feature.
            getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW, { opacity: this.feature.opacity });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_OPICITY, 'onChange')
    public changeOpacity(opacity: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const opacityObj = this.feature.getValidValue({ opacity }, from);
        this.feature.shadowInfo.tdColor?.updateOpacity?.(opacity);
        this.feature.handleShadowChange(opacityObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_ANGLE, 'value')
    public getAngle(): number | IMultiDiffValue {
        let dir: any = this.feature.shadowProps?.dir;
        if (typeof dir !== 'number') {
            dir =  Number(dir?.match(/\d*/)[0]);
        }
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW, { dir });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_ANGLE, 'onChange')
    public changeAngle(value: number, from: AngleFrom, dragState?: DragAngleCircleType): void {
        const { dir } = this.feature.getValidValue({ dir: value }, from, ANGLE_MAX);
        // dragState不存在表明数据变更来源于输入框
        const dragEnd = !dragState || dragState === DragAngleCircleType.STOP;
        this.feature.handleShadowChange({ dir: dir % 360 }, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_SHADOW_COLOR, 'content')
    public getColorSelectButton() {
        return this.feature.getColorSelectButton();
    }
}
